"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Constants = void 0;
Object.defineProperty(exports, "clearSuggestedActions", {
  enumerable: true,
  get: function get() {
    return _clearSuggestedActions["default"];
  }
});
Object.defineProperty(exports, "connect", {
  enumerable: true,
  get: function get() {
    return _connect["default"];
  }
});
Object.defineProperty(exports, "createStore", {
  enumerable: true,
  get: function get() {
    return _createStore["default"];
  }
});
Object.defineProperty(exports, "createStoreWithDevTools", {
  enumerable: true,
  get: function get() {
    return _createStore.withDevTools;
  }
});
Object.defineProperty(exports, "createStoreWithOptions", {
  enumerable: true,
  get: function get() {
    return _createStore.withOptions;
  }
});
Object.defineProperty(exports, "disconnect", {
  enumerable: true,
  get: function get() {
    return _disconnect["default"];
  }
});
Object.defineProperty(exports, "dismissNotification", {
  enumerable: true,
  get: function get() {
    return _dismissNotification["default"];
  }
});
Object.defineProperty(exports, "emitTypingIndicator", {
  enumerable: true,
  get: function get() {
    return _emitTypingIndicator["default"];
  }
});
Object.defineProperty(exports, "isForbiddenPropertyName", {
  enumerable: true,
  get: function get() {
    return _isForbiddenPropertyName["default"];
  }
});
Object.defineProperty(exports, "markActivity", {
  enumerable: true,
  get: function get() {
    return _markActivity["default"];
  }
});
Object.defineProperty(exports, "postActivity", {
  enumerable: true,
  get: function get() {
    return _postActivity["default"];
  }
});
Object.defineProperty(exports, "sendEvent", {
  enumerable: true,
  get: function get() {
    return _sendEvent["default"];
  }
});
Object.defineProperty(exports, "sendFiles", {
  enumerable: true,
  get: function get() {
    return _sendFiles["default"];
  }
});
Object.defineProperty(exports, "sendMessage", {
  enumerable: true,
  get: function get() {
    return _sendMessage["default"];
  }
});
Object.defineProperty(exports, "sendMessageBack", {
  enumerable: true,
  get: function get() {
    return _sendMessageBack["default"];
  }
});
Object.defineProperty(exports, "sendPostBack", {
  enumerable: true,
  get: function get() {
    return _sendPostBack["default"];
  }
});
Object.defineProperty(exports, "setDictateInterims", {
  enumerable: true,
  get: function get() {
    return _setDictateInterims["default"];
  }
});
Object.defineProperty(exports, "setDictateState", {
  enumerable: true,
  get: function get() {
    return _setDictateState["default"];
  }
});
Object.defineProperty(exports, "setLanguage", {
  enumerable: true,
  get: function get() {
    return _setLanguage["default"];
  }
});
Object.defineProperty(exports, "setNotification", {
  enumerable: true,
  get: function get() {
    return _setNotification["default"];
  }
});
Object.defineProperty(exports, "setSendBox", {
  enumerable: true,
  get: function get() {
    return _setSendBox["default"];
  }
});
Object.defineProperty(exports, "setSendTimeout", {
  enumerable: true,
  get: function get() {
    return _setSendTimeout["default"];
  }
});
Object.defineProperty(exports, "setSendTypingIndicator", {
  enumerable: true,
  get: function get() {
    return _setSendTypingIndicator["default"];
  }
});
Object.defineProperty(exports, "singleToArray", {
  enumerable: true,
  get: function get() {
    return _singleToArray["default"];
  }
});
Object.defineProperty(exports, "startDictate", {
  enumerable: true,
  get: function get() {
    return _startDictate["default"];
  }
});
Object.defineProperty(exports, "startSpeakingActivity", {
  enumerable: true,
  get: function get() {
    return _startSpeakingActivity["default"];
  }
});
Object.defineProperty(exports, "stopDictate", {
  enumerable: true,
  get: function get() {
    return _stopDictate["default"];
  }
});
Object.defineProperty(exports, "stopSpeakingActivity", {
  enumerable: true,
  get: function get() {
    return _stopSpeakingActivity["default"];
  }
});
Object.defineProperty(exports, "submitSendBox", {
  enumerable: true,
  get: function get() {
    return _submitSendBox["default"];
  }
});
exports.version = void 0;
Object.defineProperty(exports, "warnOnce", {
  enumerable: true,
  get: function get() {
    return _warnOnce["default"];
  }
});

var ActivityClientState = _interopRequireWildcard(require("./constants/ActivityClientState"));

var DictateState = _interopRequireWildcard(require("./constants/DictateState"));

var _clearSuggestedActions = _interopRequireDefault(require("./actions/clearSuggestedActions"));

var _connect = _interopRequireDefault(require("./actions/connect"));

var _createStore = _interopRequireWildcard(require("./createStore"));

var _disconnect = _interopRequireDefault(require("./actions/disconnect"));

var _dismissNotification = _interopRequireDefault(require("./actions/dismissNotification"));

var _emitTypingIndicator = _interopRequireDefault(require("./actions/emitTypingIndicator"));

var _isForbiddenPropertyName = _interopRequireDefault(require("./utils/isForbiddenPropertyName"));

var _markActivity = _interopRequireDefault(require("./actions/markActivity"));

var _postActivity = _interopRequireDefault(require("./actions/postActivity"));

var _sendEvent = _interopRequireDefault(require("./actions/sendEvent"));

var _sendFiles = _interopRequireDefault(require("./actions/sendFiles"));

var _sendMessage = _interopRequireDefault(require("./actions/sendMessage"));

var _sendMessageBack = _interopRequireDefault(require("./actions/sendMessageBack"));

var _sendPostBack = _interopRequireDefault(require("./actions/sendPostBack"));

var _setDictateInterims = _interopRequireDefault(require("./actions/setDictateInterims"));

var _setDictateState = _interopRequireDefault(require("./actions/setDictateState"));

var _setLanguage = _interopRequireDefault(require("./actions/setLanguage"));

var _setNotification = _interopRequireDefault(require("./actions/setNotification"));

var _setSendBox = _interopRequireDefault(require("./actions/setSendBox"));

var _setSendTimeout = _interopRequireDefault(require("./actions/setSendTimeout"));

var _setSendTypingIndicator = _interopRequireDefault(require("./actions/setSendTypingIndicator"));

var _singleToArray = _interopRequireDefault(require("./utils/singleToArray"));

var _startDictate = _interopRequireDefault(require("./actions/startDictate"));

var _startSpeakingActivity = _interopRequireDefault(require("./actions/startSpeakingActivity"));

var _stopDictate = _interopRequireDefault(require("./actions/stopDictate"));

var _stopSpeakingActivity = _interopRequireDefault(require("./actions/stopSpeakingActivity"));

var _submitSendBox = _interopRequireDefault(require("./actions/submitSendBox"));

var _warnOnce = _interopRequireDefault(require("./utils/warnOnce"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var Constants = {
  ActivityClientState: ActivityClientState,
  DictateState: DictateState
};
exports.Constants = Constants;
var version = "4.15.9";
exports.version = version;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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